<template>
	<tr class="border-b">
		<td class="flex items-center py-6 px-4">
			<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0 mr-6">
				<img :src="item.variant?.imageUrl || item.item.images?.find((image) => image.isThumbnail)?.url" class="w-full max-w-[80px] max-h-[80px] object-contain" />
			</div>
			<div class="flex flex-col text-start px-4">
				<router-link
					:to="`/products/${item.item.id}`"
					class="items-center cursor-pointer text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2 font-semibold"
				>
					{{ item.item.name }}
				</router-link>
				<div v-if="item.item.brand?.name" class="text-ihh-slate-gray mt-0 pt-0 mb-2 items-top text-xs">
					{{ item.item.brand?.name }}
				</div>
				<div v-if="filteredOptionSelections?.length" class="mt-1">
					<div v-for="option in filteredOptionSelections" :key="option.id" class="text-xs text-ihh-midnight-gray">
						<span class="font-semibold">{{ `${option.option_name}: ` }}</span>
						<span class="text-ihh-gray">{{ option.option_value }}</span>
					</div>
				</div>
				<div v-if="item.variant" class="text-ihh-midnight-gray font-medium mt-2 text-xs">
					<div v-for="option in item.variant.optionValues" :key="option.label">
						<span class="text-ihh-midnight-gray font-semibold">{{ `${option.optionDisplayName}: ` }}</span>
						<span class="text-ihh-gray-700 font-normal">{{ option.label }}</span>
					</div>
				</div>
				<div v-if="bulkPricingActive" class="text-xs mt-2">
					<span class="bg-ihh-check rounded py-1 px-2 text-ihh-midnight-gray font-ihh-bold">Bulk Pricing Unlocked!</span>
				</div>
				<div v-if="XCoverProducts.includes(item.item?.bcId)" class="text-ihh-midnight-gray font-medium mt-2">
					<div class="text-xs">
						<span>{{ `Covered Product Code: ` }}</span>
						<span class="text-ihh-gray font-normal">{{ item.optional?.coveredProductCode }}</span>
					</div>
					<div class="text-xs">
						<span>{{ `Covered Product: ` }}</span>
						<span class="text-ihh-gray font-normal">{{ item.optional.productName }}</span>
					</div>
				</div>
			</div>
		</td>
		<td v-if="!hasDiscountPrice" class="py-6 px-4 text-center text-ihh-slate-gray">${{ item.price?.originalPrice?.toFixed(2) || formattedPrice }}</td>
		<td v-else class="py-6 px-4 text-center text-ihh-slate-gray relative">
			<div class="absolute left-0 right-0 bottom-6 text-center text-base font-semibold">${{ item.price?.salePrice?.toFixed(2) || formattedPrice }}</div>
			<div class="line-through">${{ item.price?.originalPrice?.toFixed(2) || basePrice?.toFixed(2) }}</div>
		</td>
		<td class="py-6 px-4 text-center text-ihh-slate-gray font-semibold">
			<div class="flex w-full justify-center">
				<div class="flex w-28 justify-around max-w-[100px]">
					<button
						@click="emitReduceQty"
						class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
					>
						-
					</button>
					<div class="m-auto text-sm">{{ item.quantity }}</div>
					<button
						@click="emitIncreaseQty"
						class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
					>
						+
					</button>
				</div>
			</div>
		</td>
		<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
			<div class="flex w-full justify-center">
				<div class="flex m-auto items-center space-x-4">
					<span> ${{ item?.price?.extendedSalePrice?.toFixed(2) || lineTotal }} </span>
				</div>
			</div>
		</td>
		<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
			<div class="flex w-full justify-center m-auto gap-x-2 sm:gap-x-6">
				<div>
					<button
						@click="emitRemoveItem"
						class="flex group w-7 h-7 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
					>
						<div class="m-auto items-center flex w-full justify-center">
							<div class="rotate-45 absolute bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
							<div class="-rotate-45 bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
						</div>
					</button>
				</div>
			</div>
		</td>
	</tr>
</template>

<script>
import Swal from 'sweetalert2'
export default {
	name: 'CartItemDesktop',
	props: {
		item: {
			type: Object,
			required: true,
			validator: (item) => 'item' in item && 'quantity' in item,
		},
		XCoverProducts: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		emitReduceQty() {
			this.$emit('reduce-qty', this.item.variant?.id || this.item.item.id)
		},
		emitIncreaseQty() {
			if (this.item?.quantity + this.purchaseIncrement <= this.currentStock) {
				this.$emit('increase-qty', this.item.variant?.id || this.item.item.id)
			} else {
				Swal.fire({
					icon: 'warning',
					title: `Only ${this.currentStock} left in stock!`,
					text: `"${this.item?.item?.name}" has low stock.`,
					confirmButtonColor: '#e59789',
				})
			}
		},
		emitRemoveItem() {
			this.$emit('remove-item', this.item.variant?.id || this.item.item.id)
		},
	},
	computed: {
		currentPrice() {
			// If no variant or quantity is invalid, return the regular price
			if (!this.item.variant?.currentPrice || !this.item.quantity || this.item.quantity <= 0) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// If no bulk pricing rules available, return the regular price
			if (!this.item.item?.bulkPricingRules || this.item.item.bulkPricingRules.length === 0) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// Find the applicable bulk pricing rule based on quantity
			const applicableRule = this.item.item.bulkPricingRules
				.filter((rule) => this.item.quantity >= rule.quantityMin && (rule.quantityMax === 0 || this.item.quantity <= rule.quantityMax))
				.sort((a, b) => b.quantityMin - a.quantityMin)[0] // Get the rule with the highest min quantity that applies

			// If no applicable rule found, return the regular price
			if (!applicableRule) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// Base price to apply discount to
			const basePrice = this.item.variant?.currentPrice || this.item.item?.currentPrice

			// Calculate price based on the rule type
			switch (applicableRule.type) {
				case 'price':
					// Price adjustment per product (subtract the amount from the original price)
					return basePrice - applicableRule.amount
				case 'percent':
					// Percentage discount (apply percentage reduction to original price)
					return basePrice * (1 - applicableRule.amount / 100)
				case 'fixed':
					// Fixed price regardless of original price
					return applicableRule.amount
				default:
					return basePrice
			}
		},
		basePrice() {
			return this.item.variant?.currentPrice || this.item.item?.currentPrice
		},
		bulkPricingActive() {
			return (
				this.item.item?.bulkPricingRules?.length > 0 &&
				!!this.item.item.bulkPricingRules
					.filter((rule) => this.item.quantity >= rule.quantityMin && (rule.quantityMax === 0 || this.item.quantity <= rule.quantityMax))
					.sort((a, b) => b.quantityMin - a.quantityMin)[0]
			)
		},
		formattedPrice() {
			if (!this.item?.price?.originalPrice) return this.currentPrice?.toFixed(2)
			return this.item.price.originalPrice.toFixed(2)
		},
		discountPrice() {
			return this.item?.price?.salePrice?.toFixed(2)
		},
		hasDiscountPrice() {
			// Return true IF:
			// 1. The original price is not equal to the sale price
			// 2. The discount price is not null
			// 3. The original price is not null
			if (!this.item?.price) return false
			return this.item?.price?.originalPrice !== this.item?.price?.salePrice && !!this.discountPrice && !!this.item?.price?.originalPrice
		},
		lineTotal() {
			return (this.currentPrice * this.item.quantity).toFixed(2)
		},
		currentStock() {
			const product = this.item?.item
			const variant = this.item?.variant
			if (product?.inventoryTracking == 'none') return 500
			if (product?.inventoryTracking == 'variant') {
				return variant?.inventoryLevel
			} else if (product?.inventoryTracking == 'product') {
				return product?.inventoryLevel
			}
		},
		purchaseIncrement() {
			// Required purchase increment: the variant's wins, falling back to the product's, then 1.
			const variantInc = Number(this.item?.variant?.purchaseIncrement)
			if (Number.isFinite(variantInc) && variantInc > 0) return variantInc
			const productInc = Number(this.item?.item?.purchaseIncrement)
			if (Number.isFinite(productInc) && productInc > 0) return productInc
			return 1
		},
		stockAvailable() {
			if (this.currentStock > this.item?.quantity) {
				return true
			} else {
				return false
			}
		},
		filteredOptionSelections() {
			if (!this.item?.optionSelections?.length) return []
			return this.item.optionSelections.filter((option) => {
				const optionName = option.option_name?.toLowerCase() || ''
				return !optionName.includes('file')
			})
		},
	},
}
</script>
